<div class="d-flex align-items-stretch me-3 menu-header">
    <div class="header-logo">
        <a href="javascript:void(0)" style="margin-left: 25px; margin-right: 25px">
            <img alt="Logo" src="../../../../../assets/media/logos/{{ IA }}" class="logo-sticky" style="height: 60px" />
        </a>
    </div>

    <div class="header-menu-wrapper header-menu-wrapper-left" id="kt_header_menu_wrapper">
        <ul class="menu-nav">
            <li class="menu-item menu-item-rel" routerLinkActive="menu-item-active">
                <a class="menu-link" [routerLink]="['/home']" [routerLinkActive]="['active']">
                    <span class="menu-text"><i class="fas fa-home"></i> Home</span>
                    <ng-container *ngIf="rootArrowEnabled">
                        <i class="menu-arrow"></i>
                    </ng-container>
                </a>
            </li>

            <li class="menu-item menu-item-rel" routerLinkActive="menu-item-active" *ngIf="false">
                <a class="menu-link" [routerLink]="['/idmshome']" [routerLinkActive]="['active']">
                    <span class="menu-text" translate="MENU.DASHBOARD"> Dashboard</span>
                    <ng-container *ngIf="rootArrowEnabled">
                        <i class="menu-arrow"></i>
                    </ng-container>
                </a>
            </li>

            <li class="menu-item menu-item-rel" routerLinkActive="menu-item-active" *ngIf="false">
                <a class="menu-link" [routerLink]="['/plant-manger']" [routerLinkActive]="['active']">
                    <span class="menu-text" translate="MENU.DASHBOARD">Plant Manager</span>
                    <ng-container *ngIf="rootArrowEnabled">
                        <i class="menu-arrow"></i>
                    </ng-container>
                </a>
            </li>

            <li class="menu-item menu-item-rel" routerLinkActive="menu-item-active" *ngIf="false">
                <a class="menu-link" [routerLink]="['/projectmanager']" [routerLinkActive]="['active']">
                    <span class="menu-text">Project Manager</span>
                    <ng-container *ngIf="rootArrowEnabled">
                        <i class="menu-arrow"></i>
                    </ng-container>
                </a>
            </li>

            <li class="menu-item menu-item-rel" routerLinkActive="menu-item-active" *ngIf="false">
                <a class="menu-link" [routerLink]="['/reports']" [routerLinkActive]="['active']">
                    <span class="menu-text">Reports</span>
                    <ng-container *ngIf="rootArrowEnabled">
                        <i class="menu-arrow"></i>
                    </ng-container>
                </a>
            </li>
        </ul>
    </div>
</div>
